import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Pricings from '../components/Pricings'
import HeroImages from '../components/HeroImages'


const Pricing = () => {

    return (
        <div>
            <Navbar />
            <HeroImages heading='PRICING' text='Choose your trip.' />
            <Pricings />
            <Footer />
        </div>
    )
}

export default Pricing